/**
 * Révélation des coordonnées hébergeur au clic.
 *
 * Le HTML ne contient qu'un payload opaque (base64 inversé). On ne le décode
 * qu'au moment où un humain clique : un crawler qui exécute le JS mais ne clique
 * pas n'obtient rien non plus.
 *
 * Voir snippets/loven-contact-reveal.liquid pour les limites de l'approche.
 */
(function () {
  'use strict';

  // base64 inversé -> texte. TextDecoder pour gérer correctement les accents.
  function decodePayload(payload) {
    var b64 = payload.split('').reverse().join('');
    var binary = atob(b64);
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new TextDecoder('utf-8').decode(bytes);
  }

  function reveal(button) {
    var payload = button.getAttribute('data-loven-payload');
    var kind = button.getAttribute('data-loven-reveal');
    if (!payload) return;

    var value;
    try {
      value = decodePayload(payload);
    } catch (e) {
      return; // en cas d'échec on laisse le bouton en place, rien ne casse
    }

    if (kind === 'url') {
      // Ouverture directe : l'URL n'est jamais écrite dans le DOM.
      window.open(value, '_blank', 'noopener');
      return;
    }

    // Téléphone : on remplace le bouton par un lien tel: cliquable.
    var link = document.createElement('a');
    link.href = 'tel:' + value.replace(/\s/g, '');
    link.textContent = value;
    link.className = 'loven-reveal__value';
    button.replaceWith(link);
  }

  // Délégation : fonctionne aussi si le bloc est injecté après coup (ajax, onglets).
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-loven-reveal]');
    if (button) reveal(button);
  });
})();
